import { RichTextContent } from 'contentful'

interface IHeading {
  teamSectionHeading: string
  teamSectionDescription: RichTextContent
}

export function Heading({
  teamSectionHeading,
  teamSectionDescription,
}: IHeading) {
  return (
    <div className="p-0 pb-10 m-auto text-center max-w-[745px] md:px-4 md:pt-16 md:pb-12 lg:px-0 lg:pt-24">
      <h3 className="mb-8 text-5xl font-bold text-acai">
        {teamSectionHeading}
      </h3>

      <div className="font-normal">
        {teamSectionDescription.content?.map((item, index) => (
          <p key={index} className="text-acai leading-normal text-[17px]">
            {item.content?.map((contentsItem, contentsIndex) => (
              <span key={contentsIndex}>{contentsItem?.value}</span>
            ))}
          </p>
        ))}
      </div>
    </div>
  )
}
